import Slider from "react-slick";
import "./carousel.css";
import GovtHospital from "../../assets/GovtHospital.png"
import HighCourt from "../../assets/HighCourt.png"
import HindonRiver from "../../assets/HindonRiver.png"
import MedicalCollege from "../../assets/MedicalCollege.png"
export default function Carousel() {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000
  };

  return (
    <div className="carousel-container">
      <Slider {...settings}>

        {/* 🎥 YouTube Video */}
        <div className="slide">
          <iframe
            width="90%"
            height="400"
            src="https://www.youtube.com/embed/6tVwSRdov4I"
            title="YouTube video"
            allowFullScreen
          ></iframe>
        </div>

        {/* 🌊 Hindon River */}
        <div className="slide">
          <img src={HindonRiver} alt="Hindon River" />
          <h3>Hindon River Movement</h3>
        </div>

        {/* 🏥 Govt Hospital */}
        <div className="slide">
          <img src={GovtHospital} alt="Hospital" />
          <h3>Government Hospital Issues</h3>
        </div>

        {/* ⚖️ High Court */}
        <div className="slide">
          <img src={HighCourt} alt="High Court" />
          <h3>High Court in West UP</h3>
        </div>

        {/* 🎓 Medical College */}
        <div className="slide">
          <img src={MedicalCollege} alt="Medical College" />
          <h3>Medical Colleges</h3>
        </div>

      </Slider>
    </div>
  );
}